export { default } from './ProcessCitationCard';
